import useSWR from "swr";
import { useSearchParams } from "react-router-dom";

import { useApiAccess } from "./useApiAccess";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { getCategory } from "../../Service/CategoryService";

export const useAllCategories = () => {

    const hasAccess = useApiAccess();
    const [ searchParams ] = useSearchParams();
    const productParam = searchParams.get('product');

    const pathParams = {
        ...(productParam && { product: productParam }),
    };

    return useSWR(
        hasAccess ? `${apiRoutes.categories}${productParam}` : null,
        () => getCategory(pathParams)
    );
}